import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";

import { HeaderService } from "../../services/header.service";
import { Country } from "../../shared/models/country";
import { Request } from "../../shared/models/request";
import { ZipCode } from "../../shared/models/zipcode";

@Injectable()
export class ExamineeRequestService {
  private _req: Request;
  public get currentRequest(): Request {
    const req = this._req;
    this._req = undefined;
    return req;
  }
  public set currentRequest(req: Request) {
    this._req = req;
  }

  constructor(
    private http: Http,
    private _http: HttpClient,
    public headerService: HeaderService
  ) {}
  getExamineeRequest(requestId) {
    return this._http.get(`/api/Request/getRequestForStepper`, {
      params: { type: requestId },
      responseType: "json"
    });
  }

  getRequestStatusCode(requestStatusCodeId) {
    return this._http.get(`/api/RequestStatusCode/getRequestStatusCode`, {
      params: { type: requestStatusCodeId },
      responseType: "json"
    });
  }

  getPerson(personId: string): Observable<Object> {
    return this._http.get(`/api/person/Person`, {
      params: { type: personId },
      responseType: "json",
      observe: "response"
    });
  }
  getPersonName(personId: string): Observable<Object> {
    return this._http.get(`/api/PersonName/getPersonName`, {
      params: { type: personId },
      responseType: "json",
      observe: "response"
    });
  }
  getPersonAddress(personId: string): Observable<Object> {
    return this._http.get(`/api/PersonAddress/getPersonAddressById`, {
      params: { type: personId },
      responseType: "json",
      observe: "response"
    });
  }
  saveExamineeRequest(request: any): Observable<Object> {
    request.organization = this.headerService.getselectedOrgDetails();
    return this.http.post("/api/Examinees/save", request).map(res => {
      const data = (<any>res).json();
      return <Request>{
        personId: data.results["PERSON_ID"],
        requestId: data.results["REQUEST_ID"],
        taaPin: data.results.user.taaPin,
        personName: data.results.user.personName,
        activeIdx: data.results["REQUEST_STATE_TX"]
      };
    });
  }

  lookupZipCode(zipcode: string): Observable<ZipCode[]> {
    if (!zipcode) {
      return Observable.of([]);
    }
    return this.http
      .get(`/api/Zipcodes/getZipCodeLookUpByUrl/${zipcode}`)
      .map(res => {
        const data = res.json();
        if (!data.zips) {
          return [];
        }
        return data.zips;
      });
  }

  getCountries(): Observable<Country[]> {
    const preferences = [, ,];
    return this.http
      .get("/api/Countries/getCountriesByUrl")
      .map(res => {
        return (<any>res).json();
      })
      .map(res => {
        let data = <Country[]>res.data.filter(obj => {
          if (obj.id === "US") {
            preferences[0] = obj;
            return false;
          } else if (obj.id === "CA") {
            preferences[1] = obj;
            return false;
          }
          return obj.status === "active";
        });
        data = data.sort((a, b) => {
          if (a.order && b.order) {
            return a.order - b.order;
          } else if (!a.order && !b.order) {
            return a.value === b.value ? 0 : a.value > b.value ? 1 : -1;
          } else {
            return a.order ? -1 : b.order ? 1 : 0;
          }
        });
        data.unshift(...preferences);
        return data;
      });
  }
}



// WEBPACK FOOTER //
// ./client/views/request/examinee/examinee-request.service.ts